

exports.__esModule = true;

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _index = require('squid/index');

var _index2 = require('xo-models/src/checkout/index');

var _index3 = require('xo-models/src/user/index');

var _util = require('pages/xo-login/util');

var _uiRouter = require('uiRouter');

require('xo-page-components/src/value-props/directive');

require('xo-title/dist/directive');

require('xo-ui-components/src/message/directive');

require('xo-ui-components/src/error-tooltip/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('$xoEConsentPageDirective', {

    tag: 'xo-econsent-page',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },

        success: {
            type: 'var',
            required: true
        }
    },

    resolve: {
        models: function models() {

            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token),
                eConsent: _index3.$EConsentModel.instance(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _index.$locale;
        }
    },

    actions: {
        submit: function submit() {
            var _this = this;

            var self = this;
            return _angular.$q.all([this.models.eConsent.save({

                batch: {
                    name: 'econsent',
                    id: 'accept'
                }
            }), this.models.checkoutSession.action('create', {

                data: {
                    baToken: this.models.checkoutCart.get('billing.ba_token'),
                    preselected_fi_type: this.models.checkoutAppData.is_second_button_txn ? 'credit' : undefined
                },

                success: function success(result) {

                    _logger.$logger.info('checkout_fpti', {
                        from: 'CREATE_XO_SESSION',
                        to: 'process_create_xo_session'
                    });

                    // consider negative balance first
                    if (self.models.checkoutSession.negBals) {
                        return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                    }

                    // Handle routing to cape for second button
                    if (self.models.checkoutAppData.is_second_button_txn) {
                        return _util.$capeRedirectUtil.handleCapeRouting(result, self.props.token);
                    }
                },


                batch: {
                    name: 'econsent',
                    id: 'createCheckout',
                    dependencies: ['accept']
                }
            })]).then(function () {
                if (!self.models.checkoutAppData.is_second_button_txn) {
                    return _this.props.success();
                }
            });
        }
    }
});


_angular.$q;

_logger.$logger;

_index.$Component;

_index.$locale;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;

_index3.$EConsentModel;

_util.$capeRedirectUtil;

_uiRouter.$state;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-eConsent/directive.js
// module id = ./pages/xo-eConsent/directive.js
// module chunks = 1